export default function () {
    var defaultOptions = {
        ignore: [],
        validClass: "has-success",
        errorClass: "has-error",
        highlight: function (element, errorClass, validClass) {
            $(element)
                .closest(".form-group")
                .addClass("has-error");

            if ($(".has-error").length > 0) {
                if ($(".custom-errors").length > 0) {
                    $(".custom-errors").removeClass("d-none");
                }
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element)
                .closest(".form-group")
                .removeClass("has-error");

            if ($(".has-error").length == 0) {
                if ($(".custom-errors").length > 0) {
                    $(".custom-errors").addClass("d-none");
                }
            }
        }
    };

    $.validator.setDefaults(defaultOptions);

    $.validator.unobtrusive.options = {
        errorClass: defaultOptions.errorClass
    };

    // Date validator
    $.validator.addMethod("date", function (value, element) {
        var dateRegex = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
        return this.optional(element) || dateRegex.test(value);
    });

    // Required checkbox validator
    $.validator.unobtrusive.adapters.addBool("checkboxrequired", "required");

    // Phone number validator
    $.validator.unobtrusive.adapters.addBool("phonenumber", "required");

    // Required if validator
    $.validator.addMethod(
        "requiredif",
        function (value, element, params) {
            var requiredFieldval = "";
            var target = "";

            if (!params.targetval.undefined) {
                target = params.targetval;
            }

            requiredFieldval = $("#" + params.requirediffield);
            requiredFieldval = requiredFieldval.val();

            if (requiredFieldval === target && (value == null || value == "")) {
                return false;
            }

            return true;
        },
        ""
    );

    $.validator.unobtrusive.adapters.add(
        "requiredif",
        ["targetval", "requirediffield"],
        function (options) {
            options.rules["requiredif"] = {
                targetval: options.params.targetval,
                requirediffield: options.params.requirediffield
            };
            options.messages["requiredif"] = options.message;
        }
    );

    if ($.validator && $.validator.unobtrusive) {
        $.validator.addMethod('islessthan', function (value, element, params) {
            value = Date.parse(value.toString().replace(/([0-9]+)\/([0-9]+)/, '$2/$1'));
            var formatotherDate = params.otherproperty.replace("=", "='").replace("]", "']");
            var otherDate = Date.parse($(formatotherDate).val().toString().replace(/([0-9]+)\/([0-9]+)/, '$2/$1'));
            var myDate = new Date(otherDate);
            myDate.setFullYear(myDate.getFullYear() + parseInt(params.yearstoadd));
            myDate = Date.parse(myDate);
            if (isNaN(value) || isNaN(myDate))
                return true;
            return value < myDate || value === myDate;
        });
        $.validator.unobtrusive.adapters.add('islessthan', ['otherproperty', 'yearstoadd'], function (options) {
            var params = {
                otherproperty: "input[name=" + options.params.otherproperty + "]",//"#" + options.params.otherproperty,
                yearstoadd: options.params.yearstoadd
            };
            options.rules['islessthan'] = params;
            //{
            //  compareTo: '#' + options.params.otherproperty
            //};
            options.messages['islessthan'] = options.message;
        });
    }

    // IsLessThan validator
    //$.validator.addMethod("islessthan", function (value, element, params) {
    //    value = Date.parse(value.toString().replace(/([0-9]+)\/([0-9]+)/, "$2/$1"));
    //    var otherDate = Date.parse(
    //        $(params.compareTo)
    //            .val()
    //            .toString()
    //            .replace(/([0-9]+)\/([0-9]+)/, "$2/$1")
    //    );
    //    if (isNaN(value) || isNaN(otherDate)) return true;
    //    return value < otherDate || value === otherDate;
    //});

    //$.validator.unobtrusive.adapters.add(
    //    "islessthan",
    //    ["otherproperty"],
    //    function (options) {
    //        options.rules["islessthan"] = {
    //            compareTo: "#" + options.params.otherproperty
    //        };
    //        options.messages["islessthan"] = options.message;
    //    }
    //);

    $.validator.unobtrusive.adapters.add("min", ["min"], function (options) {
        options.rules["min"] = parseInt(options.params["min"], 10);
        options.messages["min"] = options.message;
    });

    $.validator.addMethod("specialcharacterregex", function (value, element, regexp) {
        var re = new RegExp(regexp); return re.test(value);
    });

    $.validator.unobtrusive.adapters.addSingleVal('specialcharacterregex', "pattern");

    $.validator.unobtrusive.adapters.addBool("wholenumber", "iswholenumber");

    $.validator.addMethod("iswholenumber", function (value, element) {
        var enteredValue = parseFloat(value);
        if (isNaN(enteredValue)) return false;
        return enteredValue % 1 === 0;
    });

    $.validator.unobtrusive.adapters.addBool("minnumberofcharacters", "isminnumberofcharacters");

    $.validator.addMethod("isminnumberofcharacters", function (value, element) {
        if (value == null || value == "") {
            return false;
        }
        var isValid = value.toString().length >= 3;
        return isValid;
    });

    $.validator.addMethod('morethantodaydate', function (selectedDate, element, params) {
        selectedDate = Date.parse(selectedDate.toString().replace(/([0-9]+)\/([0-9]+)/, '$2/$1'));

        var todayDate = new Date();

        todayDate.setFullYear(todayDate.getFullYear());
        todayDate = Date.parse(todayDate);

        if (isNaN(selectedDate) || isNaN(todayDate))
            return true;

        return selectedDate > todayDate;
    });

    $.validator.unobtrusive.adapters.addBool('morethantodaydate');

    $.validator.addMethod('lessthanorequaltodaydate', function (selectedDate, element, params) {
        selectedDate = Date.parse(selectedDate.toString().replace(/([0-9]+)\/([0-9]+)/, '$2/$1'));

        var todayDate = new Date();

        todayDate.setFullYear(todayDate.getFullYear());
        todayDate = Date.parse(todayDate);

        if (isNaN(selectedDate) || isNaN(todayDate))
            return true;

        return selectedDate <= todayDate;
    });

    $.validator.unobtrusive.adapters.addBool('lessthanorequaltodaydate');

    $.validator.addMethod('validdateinpast', function (selectedYear, element, params) {
        var selectedDateFirstOfMonth = getSelectedDateFirstOfMonth(selectedYear, params);
        var todayDateFirstOfMonth = getTodayDateFirstOfMonth();

        if (isNaN(selectedDateFirstOfMonth) || isNaN(todayDateFirstOfMonth))
            return true;

        return selectedDateFirstOfMonth <= todayDateFirstOfMonth;
    });

    $.validator.unobtrusive.adapters.add(
        "validdateinpast",
        ["otherproperty"],
        function (options) {
            options.rules["validdateinpast"] = {
                compareTo: "#" + options.params.otherproperty
            };
            options.messages["validdateinpast"] = options.message;
        }
    );

    $.validator.addMethod('dateistodayorinfuture', function (selectedYear, element, params) {
        var selectedDateFirstOfMonth = getSelectedDateFirstOfMonth(selectedYear, params);
        var todayDateFirstOfMonth = getTodayDateFirstOfMonth();

        if (isNaN(selectedDateFirstOfMonth) || isNaN(todayDateFirstOfMonth))
            return true;

        return selectedDateFirstOfMonth >= todayDateFirstOfMonth;
    });

    $.validator.unobtrusive.adapters.add(
        "dateistodayorinfuture",
        ["otherproperty"],
        function (options) {
            options.rules["dateistodayorinfuture"] = {
                compareTo: "#" + options.params.otherproperty
            };
            options.messages["dateistodayorinfuture"] = options.message;
        }
    );

    function getSelectedDateFirstOfMonth(selectedYear, params) {
        var selectedMonth = $(params.compareTo).val().toLowerCase();
        var months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
        var monthIndex = months.indexOf(selectedMonth) + 1;

        var year = parseInt(selectedYear);
        var selectedDateFirstOfMonth = new Date(year, monthIndex);

        selectedDateFirstOfMonth = Date.parse(selectedDateFirstOfMonth);

        return selectedDateFirstOfMonth;
    }

    function getTodayDateFirstOfMonth() {
        var todayDate = new Date();
        var todayMonth = todayDate.getMonth() + 1;
        var todayYear = todayDate.getFullYear();
        var todayDateFirstOfMonth = new Date(todayYear, todayMonth);

        todayDateFirstOfMonth = Date.parse(todayDateFirstOfMonth);

        return todayDateFirstOfMonth;
    }

    $.validator.unobtrusive.adapters.add(
        'atleastonerequired', ['properties'], function (options) {
            options.rules['atleastonerequired'] = options.params;
            options.messages['atleastonerequired'] = options.message;
        }
    );

    $.validator.addMethod('atleastonerequired', function (value, element, params) {
        var properties = params.properties.split(',');
        var propertiesExist = false;
        var filterProps = [];

        /*IC-2545*/
        if (properties.length > 0) {
            properties.forEach(function (value) {
                if ($('#' + value).length) {
                    propertiesExist = true;
                }
            });

            if (!propertiesExist) {
                properties.forEach(function (value) {
                    var prop = value.split("_")[1];
                    if (prop != undefined && $('#' + prop).length) {
                        propertiesExist = true;
                        filterProps.push(prop);
                    }
                });

                if (propertiesExist) {
                    var values = $.map(filterProps, function (property, index) {
                        var val = $('#' + property).val();
                        return val != '' ? val : null;
                    });
                    return values.length > 0;
                }
            }
            else {
                var values = $.map(properties, function (property, index) {
                    var val = $('#' + property).val();
                    return val != '' ? val : null;
                });
                return values.length > 0;
            }
        }

        return true;
    }, '');

    // Required if contains validator
    $.validator.addMethod(
        "requiredifcontains",
        function (value, element, params) {
            var requiredFieldval = "";
            var target = "";

            if (!params.targetval.undefined) {
                target = params.targetval.split(";");
            }

            requiredFieldval = $("[id$='" + params.requiredifcontainsfield + "']").val();

            if (target.includes(requiredFieldval) && (value == null || value == "")) {
                return false;
            }

            return true;
        },
        ""
    );

    $.validator.unobtrusive.adapters.add(
        "requiredifcontains",
        ["targetval", "requiredifcontainsfield"],
        function (options) {
            options.rules["requiredifcontains"] = {
                targetval: options.params.targetval,
                requiredifcontainsfield: options.params.requiredifcontainsfield,
            };
            options.messages["requiredifcontains"] = options.message;
        }
    );

    //unlike validator
    $.validator.addMethod('unlike',
        function (value, element, params) {
            var propertyValue = value;
            var dependentPropertyValue = params[0].value;
            return propertyValue !== dependentPropertyValue;
        });

    $.validator.unobtrusive.adapters.add('unlike',
        ['dependentproperty'],
        function (options) {
            var element = $(options.form).find('#' + options.params['dependentproperty'])[0];
            options.rules['unlike'] = [element, options.element];
            options.messages['unlike'] = options.message;
        });

   
}
